import React from "react";
import PropTypes from "prop-types";

import SectionContainer from "core/SectionContainer";
import PhotosPricingTable from "./PhotosPricingTable";

import {
    MarketingPageSectionEyebrowSubheading,
    MarketingPageSectionHeading,
    MarketingPageSectionBiLine
} from "core/MarketingPageSectionHeading";
import { BorderBottomLink } from "core/Typography";
import colors from "core/colors";
import {
    TableAndCardContainer,
    PhotosSectionHeadingContainer,
    Footnote,
    PageAnchor
} from "./styles";

import { heroCardData } from "./data";

const PhotosSection = ({ hideNounProjectHeading }) => {
    return (
        <PageAnchor id={heroCardData[1].sectionId}>
            <SectionContainer bgColor={colors.primary.diamond}>
                <PhotosSectionHeadingContainer>
                    {!hideNounProjectHeading && (
                        <MarketingPageSectionEyebrowSubheading>
                            Noun Project
                        </MarketingPageSectionEyebrowSubheading>
                    )}
                    <MarketingPageSectionHeading
                        type="h2"
                        size="xl"
                        alignment="center"
                    >
                        Photos Pricing
                    </MarketingPageSectionHeading>
                    <MarketingPageSectionBiLine>
                        Our mission-driven, art-quality photo collection grows
                        daily. All photos are available in both free and paid
                        options.
                    </MarketingPageSectionBiLine>
                </PhotosSectionHeadingContainer>
                <TableAndCardContainer>
                    <PhotosPricingTable />
                </TableAndCardContainer>
                <Footnote>
                    *Please see{" "}
                    <BorderBottomLink
                        href="/legal/terms-of-use/#photo-licenses"
                        target="_blank"
                    >
                        license terms
                    </BorderBottomLink>{" "}
                    for complete details.
                </Footnote>
            </SectionContainer>
        </PageAnchor>
    );
};

PhotosSection.propTypes = {
    hideNounProjectHeading: PropTypes.bool
};

export default PhotosSection;
// todo: move this to /components/ since other pages use this too
